<template>
  <div>
    <div v-if="user.role === 'OUTLET_MANAGER' || user.role === 'FINANCE'">
      <div class="p-grid p-fluid dashboard card" style="margin-bottom: 25px">
        <div class="title p-col-12">Grafik Omset Bulan {{ month_title }}</div>
        <div class="p-col-3" style="margin-top: 1.5rem">
          <AutoComplete
            class="p-col"
            placeholder="Pilih Bulan"
            :dropdown="true"
            :suggestions="month_filtered"
            v-model="month"
            @complete="setMonth($event)"
            field="name"
            optionLabel="name"
          >
            <template #item="slotProps">
              <div class="p-col">
                <div>{{ slotProps.item.name }}</div>
              </div>
            </template>
          </AutoComplete>
        </div>
        <div class="p-col-3" style="margin-top: 1.5rem">
          <AutoComplete
            class="p-col"
            placeholder="Pilih Tahun"
            :dropdown="true"
            :suggestions="year_filtered"
            v-model="year"
            @complete="setYear($event)"
          >
            <template #item="slotProps">
              <div class="p-col">
                <div>{{ slotProps.item }}</div>
              </div>
            </template>
          </AutoComplete>
        </div>
        <div class="p-col-3" style="margin-top: 2rem">
          <Button
            label="Cari"
            class="p-button-primary"
            icon="pi pi-search"
            @click="getChartOmset()"
          />
        </div>
        <div class="p-col-12">
          <div ref="barChart" style="height: 400px"></div>
        </div>
      </div>

      <div class="p-grid p-fluid dashboard" style="padding-bottom: 25px">
        <div class="card">
          <Toast />
          <div class="title">Daftar Shift</div>

          <DataTable
            :value="shifts"
            :lazy="true"
            :paginator="showShiftsPagination"
            :rows="limit"
            :totalRecords="total_records_shift"
            :first="first.shifts"
            :loading="loading.shifts"
            @page="onShiftsPage"
          >
            <template #empty>Data tidak ada</template>
            <template #loading>Loading ...</template>

            <Column field="name" header="Nama">
              <template #body="slotProps">
                {{ slotProps.data.name }}
              </template>
            </Column>
            <Column field="audit_date" header="Tanggal Audit">
              <template #body="slotProps">
                {{ slotProps.data.audit_date }}
              </template>
            </Column>
            <Column header="Mulai">
              <template #body="slotProps">
                <span v-if="slotProps.data.opened_at !== '0001-01-01 00:00:00'">
                  {{
                    moment(moment.utc(slotProps.data.opened_at).toDate())
                      .local()
                      .format('YYYY-MM-DD HH:mm:ss')
                  }}
                </span>
              </template>
            </Column>
            <Column header="Selesai">
              <template #body="slotProps">
                <span v-if="slotProps.data.closed_at !== '0001-01-01 00:00:00'">
                  {{
                    moment(moment.utc(slotProps.data.closed_at).toDate())
                      .local()
                      .format('YYYY-MM-DD HH:mm:ss')
                  }}
                </span>
              </template>
            </Column>
            <Column header="Saldo Awal">
              <template #body="slotProps">
                {{ slotProps.data.opening_balance | currency }}
              </template>
            </Column>
            <Column header="Saldo Akhir">
              <template #body="slotProps">
                {{ slotProps.data.closing_balance | currency }}
              </template>
            </Column>
            <Column field="status" header="Status">
              <template #body="slotProps">
                <span
                  v-if="slotProps.data.status === 'CLOSE'"
                  class="p-text-bold"
                  style="color: black"
                >
                  {{ slotProps.data.status }}
                </span>
                <span
                  v-else-if="slotProps.data.status === 'OPEN'"
                  class="p-text-bold"
                  style="color: green"
                >
                  {{ slotProps.data.status }}
                </span>
                <span
                  v-else-if="slotProps.data.status === 'PENDING'"
                  class="p-text-bold"
                  style="color: orange"
                >
                  {{ slotProps.data.status }}
                </span>
                <span
                  v-else-if="slotProps.data.status === 'CANCEL'"
                  class="p-text-bold"
                  style="color: grey"
                >
                  {{ slotProps.data.status }}
                </span>
                <span v-else class="p-text-bold" style="color: #666">
                  {{ slotProps.data.status || '-' }}
                </span>
              </template>
            </Column>
            <Column headerStyle="width: 5em">
              <template #body="slotProps">
                <Button
                  v-if="slotProps.data.status === 'PENDING'"
                  icon="pi pi-times"
                  class="p-button-rounded p-button-warning"
                  @click="confirmCancel(slotProps.data)"
                  :disabled="loading.cancel"
                ></Button>
              </template>
            </Column>
          </DataTable>

          <Dialog
            :visible.sync="cancelDialog"
            :style="{ width: '450px' }"
            header="Konfirmasi Pembatalan"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="cancelData">
                Apakah kamu yakin ingin membatalkan shift
                <b>{{ cancelData.name }}</b
                >?
              </span>
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="cancelDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="cancelShift()"
                :loading="loading.cancel"
              />
            </template>
          </Dialog>
        </div>
      </div>

      <div class="p-grid p-fluid dashboard" style="padding-bottom: 25px">
        <div class="card">
          <div class="title">Daftar Retur & Transfer</div>
          <DataTable
            :value="items_outbounds"
            :lazy="true"
            :paginator="showOutboundsPagination"
            class="p-datatable-outlets"
            :rows="limit"
            :totalRecords="total_records_outbonds"
            :first="first.outbounds"
            :loading="loading.outbounds"
            data-key="doc_number"
            :rowHover="true"
            @page="onOutboundsPage"
          >
            <template #empty>Data tidak ditemukan.</template>
            <template #loading
              >Mengambil data daftar retur. Mohon tunggu</template
            >
            <Column header="Tipe">
              <template #body="slotProps">
                {{ slotProps.data.type }}
              </template>
            </Column>
            <Column header="Kode Gudang">
              <template #body="slotProps">
                {{ slotProps.data.warehouse_code }}
              </template>
            </Column>
            <Column header="Nomor Bon">
              <template #body="slotProps">
                <span>{{ slotProps.data.doc_number }}</span>
              </template>
            </Column>
            <Column header="Tanggal Bon">
              <template #body="slotProps">
                <span>{{ slotProps.data.doc_date }}</span>
              </template>
            </Column>

            <Column header="Total Barang">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_item }}</span>
              </template>
            </Column>
            <Column header="Total Harga">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_price | currency }}</span>
              </template>
            </Column>
            <Column field="status" header="Status">
              <template #body="slotProps">
                <span
                  :style="
                    slotProps.data.status === 1 ? 'color:green' : 'color:red'
                  "
                >
                  <b>{{ checkStatus(slotProps.data.status) }}</b>
                </span>
              </template>
            </Column>
            <Column
              headerStyle="width: 12rem"
              bodyStyle="text-align: center; overflow: visible"
            >
              <template #body="slotProps">
                <div>
                  <router-link
                    :to="{
                      name: 'outgoing-detail',
                      query: { doc_number: slotProps.data.doc_number }
                    }"
                  >
                    <Button
                      type="button"
                      icon="pi pi-eye"
                      class="p-button-rounded p-mr-2"
                    ></Button>
                  </router-link>
                  <Button
                    v-if="slotProps.data.status === 0"
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-warning"
                    @click="confirmDelete(slotProps.data)"
                  ></Button>
                </div>
              </template>
            </Column>
          </DataTable>

          <Dialog
            :visible.sync="deleteDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="outletOutbound">
                Apakah kamu yakin ingin menghapus
                <b>{{ outletOutbound.doc_number }}</b
                >?
              </span>
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteOutletOutbound(outletOutbound.doc_number)"
              />
            </template>
          </Dialog>
        </div>
      </div>

      <div class="p-grid p-fluid dashboard">
        <div class="card">
          <div class="title">Daftar Penerimaan Barang</div>
          <DataTable
            :value="items_inbounds"
            :lazy="true"
            :paginator="showInboundsPagination"
            class="p-datatable-outlets"
            :rows="limit"
            :totalRecords="total_records_inbounds"
            :first="first.inbounds"
            :loading="loading.inbounds"
            data-key="doc_number"
            :rowHover="true"
            @page="onInboundsPage"
          >
            <template #empty>Data tidak ditemukan.</template>
            <template #loading
              >Mengambil data penerimaan barang. Mohon tunggu</template
            >
            <Column field="doc_number" header="Nomor Bon">
              <template #body="slotProps">
                {{ slotProps.data.doc_number }}
              </template>
            </Column>
            <Column field="doc_date" header="Tanggal Bon">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.doc_date }}
                </span>
              </template>
            </Column>

            <Column header="Total Barang">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_item }}</span>
              </template>
            </Column>
            <Column header="Total Qty">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_qty }}</span>
              </template>
            </Column>
            <Column header="Total Harga">
              <template #body="slotProps">
                <span>{{ slotProps.data.total_price | currency }}</span>
              </template>
            </Column>
            <Column header="Status">
              <template #body="slotProps">
                <div v-if="slotProps.data.status == 1">
                  <span style="color: green; font-weight: bold">Confirmed</span>
                </div>
                <div v-else-if="slotProps.data.status == 2">
                  <span style="color: blue; font-weight: bold">Rejected</span>
                </div>
                <div v-else>
                  <span style="color: red; font-weight: bold">Pending</span>
                </div>
              </template>
            </Column>
            <Column
              headerStyle="width: 12rem"
              bodyStyle="text-align: center; overflow: visible"
            >
              <template #body="slotProps">
                <div>
                  <router-link
                    :to="{
                      name: 'receiving-detail',
                      query: {
                        doc_number: slotProps.data.doc_number,
                        from: 'laporan barang'
                      }
                    }"
                  >
                    <Button
                      type="button"
                      icon="pi pi-eye"
                      class="p-button-rounded p-mr-2"
                    ></Button>
                  </router-link>
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-warning"
                    @click="confirmDelete(slotProps.data)"
                    v-if="
                      slotProps.data.status === 0 &&
                      user.role === 'OUTLET_MANAGER'
                    "
                  ></Button>
                </div>
              </template>
            </Column>
          </DataTable>

          <Dialog
            :visible.sync="deleteDialog"
            :style="{ width: '450px' }"
            header="Confirm"
            :modal="true"
          >
            <div class="confirmation-content">
              <i
                class="pi pi-exclamation-triangle p-mr-3"
                style="font-size: 2rem"
              />
              <span v-if="outletOutbound">
                Apakah kamu yakin ingin menghapus
                <b>{{ outletOutbound.doc_number }}</b
                >?
              </span>
            </div>
            <template #footer>
              <Button
                label="No"
                icon="pi pi-times"
                class="p-button-text"
                @click="deleteDialog = false"
              />
              <Button
                label="Yes"
                icon="pi pi-check"
                class="p-button-text"
                @click="deleteOutletOutbound(outletOutbound.doc_number)"
              />
            </template>
          </Dialog>
        </div>
      </div>
    </div>

    <div
      v-if="user && user.role === 'PURCHASING'"
      class="dashboard-purchasing-section"
    >
      <div class="dashboard-actions">
        <button class="action-btn" @click="goTo('create-purchase')">
          Tambah Pembelian
        </button>
        <button class="action-btn" @click="goTo('create-supplier')">
          Tambah Supplier
        </button>
      </div>
      <div class="card-grid">
        <div class="dashboard-card" @click="goTo('catalog')">
          <div class="card-icon">📦</div>
          <div class="card-title">Katalog</div>
          <div class="card-desc">Lihat & kelola produk</div>
        </div>
        <div class="dashboard-card" @click="goTo('purchase')">
          <div class="card-icon">🛒</div>
          <div class="card-title">Pembelian</div>
          <div class="card-desc">Riwayat & permintaan pembelian</div>
        </div>
        <div class="dashboard-card" @click="goTo('supplier')">
          <div class="card-icon">🏢</div>
          <div class="card-title">Supplier</div>
          <div class="card-desc">Data & kontak supplier</div>
        </div>
      </div>
      <div class="card-grid">
        <div class="dashboard-card latest-card">
          <div class="card-title">Katalog Terbaru</div>
          <ul>
            <li v-for="item in latestCatalogs" :key="item.id">
              <b>{{ item.name }}</b> ({{ item.date }})
            </li>
          </ul>
        </div>
        <div class="dashboard-card latest-card">
          <div class="card-title">Pembelian Terbaru</div>
          <ul>
            <li v-for="po in recentPurchases" :key="po.id">
              <b>{{ po.po_number }}</b> - {{ po.supplier }} ({{ po.date }})
            </li>
          </ul>
        </div>
        <div class="dashboard-card latest-card">
          <div class="card-title">Supplier Terbaru</div>
          <ul>
            <li v-for="supplier in latestSuppliers" :key="supplier.id">
              <b>{{ supplier.name }}</b> ({{ supplier.date }})
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
import * as echarts from 'echarts'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated']),

    /**
     * Check if shifts pagination should be shown
     */
    showShiftsPagination() {
      const totalPages = Math.ceil(this.total_records_shift / this.limit)
      return totalPages > 1
    },

    /**
     * Check if outbounds pagination should be shown
     */
    showOutboundsPagination() {
      const totalPages = Math.ceil(this.total_records_outbonds / this.limit)
      return totalPages > 1
    },

    /**
     * Check if inbounds pagination should be shown
     */
    showInboundsPagination() {
      const totalPages = Math.ceil(this.total_records_inbounds / this.limit)
      return totalPages > 1
    }
  },
  name: 'BarChart',
  data() {
    return {
      moment: moment,
      audit_date: new Date().toISOString().split('T')[0],
      shifts: [],
      limit: 10,
      offset: 0,
      first: {
        shifts: 0,
        outbounds: 0,
        inbounds: 0
      },
      order_by: {
        shifts: 'audit_date',
        outbounds: 'doc_date',
        inbounds: 'doc_date'
      },
      items_outbounds: null,
      items_inbounds: null,
      total_records_outbonds: 0,
      total_records_shift: 0,
      total_records_inbounds: 0,
      outletOutbound: {},
      deleteDialog: false,
      cancelDialog: false,
      cancelData: null,
      month_title: null,
      month: null,
      month_filtered: null,
      months: [
        { id: '1', name: 'Januari' },
        { id: '2', name: 'Februari' },
        { id: '3', name: 'Maret' },
        { id: '4', name: 'April' },
        { id: '5', name: 'Mei' },
        { id: '6', name: 'Juni' },
        { id: '7', name: 'Juli' },
        { id: '8', name: 'Agustus' },
        { id: '9', name: 'September' },
        { id: '10', name: 'Oktober' },
        { id: '11', name: 'November' },
        { id: '12', name: 'Desember' }
      ],
      year: null,
      year_filtered: null,
      years: [],
      loading: {
        shifts: false,
        outbounds: false,
        inbounds: false,
        delete: false,
        cancel: false,
        chart: false
      },
      chartInstance: null,
      abortControllers: {
        shifts: null,
        outbounds: null,
        inbounds: null,
        chart: null
      },
      recentPurchases: [
        {
          id: 1,
          po_number: 'PO-2024-001',
          supplier: 'PT. Supplier A',
          date: '2024-06-01'
        },
        {
          id: 2,
          po_number: 'PO-2024-002',
          supplier: 'PT. Supplier B',
          date: '2024-06-03'
        },
        {
          id: 3,
          po_number: 'PO-2024-003',
          supplier: 'PT. Supplier C',
          date: '2024-06-05'
        }
      ],
      latestCatalogs: [
        { id: 1, name: 'Baju Batik', date: '2024-06-06' },
        { id: 2, name: 'Celana Jeans', date: '2024-06-05' },
        { id: 3, name: 'Sepatu Sneakers', date: '2024-06-04' }
      ],
      latestSuppliers: [
        { id: 1, name: 'PT. Supplier D', date: '2024-06-06' },
        { id: 2, name: 'PT. Supplier E', date: '2024-06-05' },
        { id: 3, name: 'PT. Supplier F', date: '2024-06-04' }
      ]
    }
  },

  async mounted() {
    this.getAuthUser()
    this.generateYears()

    try {
      await this.waitForUserData()

      if (this.user.role === 'OUTLET_MANAGER' || this.user.role === 'FINANCE') {
        // Initialize month and year
        this.month = this.months[new Date().getMonth()].name
        this.month_title = this.month
        this.year = new Date().getFullYear().toString()

        // Load data in parallel
        await Promise.allSettled([
          this.getChartOmset(),
          this.getShifts(),
          this.getReturnList(),
          this.getListOutletInbounds()
        ])
      }
    } catch (error) {
      console.error('Error initializing dashboard:', error)
      this.showToast(
        'error',
        'Error',
        'Gagal memuat dashboard. Silakan refresh halaman.'
      )
    }
  },

  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    /**
     * Generate years array dynamically
     */
    generateYears() {
      const currentYear = new Date().getFullYear()
      const years = []
      // Generate 5 years: 2 years before, current, 2 years after
      for (let i = currentYear - 2; i <= currentYear + 2; i++) {
        years.push(i.toString())
      }
      this.years = years
    },

    /**
     * Wait for user data to be available in Vuex store
     * @returns {Promise} Resolves when user.role is available
     */
    waitForUserData() {
      return new Promise((resolve, reject) => {
        const maxAttempts = 50 // 5 seconds max wait (50 * 100ms)
        let attempts = 0

        const checkUser = () => {
          attempts++

          // Check if user and role are available
          if (
            this.user &&
            this.user.role !== undefined &&
            this.user.role !== null
          ) {
            resolve()
            return
          }

          // If max attempts reached, reject
          if (attempts >= maxAttempts) {
            reject(
              new Error(
                'User data tidak tersedia. Silakan refresh halaman atau login ulang.'
              )
            )
            return
          }

          // Check again after 100ms
          setTimeout(checkUser, 100)
        }

        // Start checking
        checkUser()
      })
    },

    async setMonth(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.month_filtered = [...this.months]
        } else {
          this.month_filtered = this.months.filter(item => {
            return item.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    async setYear(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.year_filtered = this.years
        } else {
          this.year_filtered = this.years.filter(item => {
            return item.toLowerCase().includes(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    async getChartOmset() {
      if (this.month == null || this.year === '') {
        this.showToast(
          'error',
          'Error',
          'Pilih bulan dan tahun terlebih dahulu'
        )
        return
      }

      // Cancel previous request if exists
      if (this.abortControllers.chart) {
        this.abortControllers.chart.abort()
      }
      this.abortControllers.chart = new AbortController()

      // Dispose existing chart if any
      if (this.chartInstance) {
        this.chartInstance.dispose()
        this.chartInstance = null
      }

      this.months.forEach(item => {
        if (item.name === this.month) {
          this.month = item
        }
      })

      this.loading.chart = true

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/omset-chart?month=${this.month.id}&year=${this.year}`,
          {
            signal: this.abortControllers.chart.signal
          }
        )

        if (response.status === 200) {
          this.month_title = this.month.name

          // Wait for DOM to be ready
          await this.$nextTick()

          // Check if ref exists
          if (!this.$refs.barChart) {
            console.warn('Chart container not found')
            return
          }

          // Initialize chart
          this.chartInstance = echarts.init(this.$refs.barChart)

          const data = {
            categories: response.data.data.omset_chart.map(item => item.day),
            values: response.data.data.omset_chart.map(item => item.total_omset)
          }

          const options = {
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'shadow'
              }
            },
            xAxis: {
              type: 'category',
              data: data.categories
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                data: data.values,
                type: 'bar',
                label: {
                  show: true,
                  position: 'top',
                  formatter: function (params) {
                    let value = params.value
                    let filteredValues = data.values.filter(val => val != 0)
                    let max = Math.max(...filteredValues)
                    let min = Math.min(...filteredValues)

                    if (value == max || value == min) {
                      if (value != 0) {
                        return value
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                      } else {
                        return ''
                      }
                    } else {
                      return ''
                    }
                  }
                },
                emphasis: {
                  label: {
                    formatter: function (params) {
                      let value = params.value
                      let filteredValues = data.values.filter(val => val != 0)
                      let max = Math.max(...filteredValues)
                      let min = Math.min(...filteredValues)

                      if (value == max || value == min) {
                        if (value != 0) {
                          return value
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                        } else {
                          return ''
                        }
                      } else {
                        return ''
                      }
                    }
                  }
                }
              }
            ]
          }

          this.chartInstance.setOption(options)

          // Handle window resize
          window.addEventListener('resize', this.handleChartResize)
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data chart')
        }
      } catch (error) {
        // Don't show error if request was aborted
        if (error.name === 'AbortError') {
          return
        }
        console.error('Error fetching chart data:', error)
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Terjadi kesalahan saat mengambil data chart'
        this.showToast('error', 'Error', errorMessage)
      } finally {
        this.loading.chart = false
      }
    },

    /**
     * Handle chart resize
     */
    handleChartResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },

    /**
     * Handle shifts pagination
     */
    onShiftsPage(event) {
      this.first.shifts = event.first
      this.getShifts(event)
    },

    async getShifts(event = null) {
      // Cancel previous request if exists
      if (this.abortControllers.shifts) {
        this.abortControllers.shifts.abort()
      }
      this.abortControllers.shifts = new AbortController()

      // Calculate offset from pagination event
      if (event) {
        this.first.shifts = event.first
        this.offset = event.first
      } else {
        this.first.shifts = 0
        this.offset = 0
      }

      // Build query parameters using URLSearchParams
      const params = new URLSearchParams({
        limit: this.limit,
        offset: this.offset,
        order_by: this.order_by.shifts
      })

      // Filter by status: PENDING and OPEN
      params.append('status', 'PENDING')
      params.append('status', 'OPEN')

      const url = `${process.env.VUE_APP_API_URL}/shifts?${params.toString()}`

      this.loading.shifts = true

      try {
        const response = await this.$http.get(url, {
          signal: this.abortControllers.shifts.signal
        })

        if (response.status === 200) {
          this.shifts = response.data.data.shifts || []
          // FIX: Use API total instead of array length
          this.total_records_shift = response.data.data.total || 0
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data shift')
        }
      } catch (error) {
        // Don't show error if request was aborted
        if (error.name === 'AbortError') {
          return
        }
        console.error('Error fetching shifts:', error)
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Terjadi kesalahan saat mengambil data shift'
        this.showToast('error', 'Error', errorMessage)
        this.shifts = []
        this.total_records_shift = 0
      } finally {
        this.loading.shifts = false
      }
    },

    confirmDelete(outletOutbound) {
      this.outletOutbound = outletOutbound
      this.deleteDialog = true
    },

    /**
     * Confirm cancel shift action
     * @param {Object} shift - Shift data to cancel
     */
    confirmCancel(shift) {
      this.cancelData = shift
      this.cancelDialog = true
    },

    /**
     * Cancel shift
     */
    async cancelShift() {
      if (!this.cancelData) return

      this.loading.cancel = true
      try {
        const response = await this.$http.put(
          `${process.env.VUE_APP_API_URL}/shifts/${this.cancelData.id}/cancel`
        )

        if (response.status === 200) {
          this.showToast('success', 'Success', 'Shift berhasil dibatalkan')
          this.cancelDialog = false
          this.cancelData = null
          this.getShifts() // Refresh list
        } else {
          this.showToast('error', 'Error', 'Gagal membatalkan shift')
        }
      } catch (error) {
        console.error('Error canceling shift:', error)
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Terjadi kesalahan saat membatalkan shift'
        this.showToast('error', 'Error', errorMessage)
      } finally {
        this.loading.cancel = false
      }
    },

    async deleteOutletOutbound(doc_number) {
      this.loading.delete = true
      try {
        const response = await this.$http.delete(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-outbounds?doc_number=${doc_number}`
        )

        if (response.status === 200) {
          this.showToast('success', 'Delete Success', 'Data berhasil dihapus')
          this.deleteDialog = false
          this.getReturnList() // Refresh list
        } else {
          this.showToast('error', 'Error', 'Gagal menghapus data')
        }
      } catch (error) {
        console.error('Error deleting outlet outbound:', error)
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Terjadi kesalahan saat menghapus data'
        this.showToast('error', 'Error', errorMessage)
      } finally {
        this.loading.delete = false
        this.deleteDialog = false
      }
    },

    checkStatus(status) {
      if (status == 1) {
        // return Confirmed Hijau
        return 'Confirmed'
      } else {
        // return Pending merah
        return 'Pending'
      }
    },

    /**
     * Handle outbounds pagination
     */
    onOutboundsPage(event) {
      this.first.outbounds = event.first
      this.getReturnList(event)
    },

    async getReturnList(event = null) {
      // Cancel previous request if exists
      if (this.abortControllers.outbounds) {
        this.abortControllers.outbounds.abort()
      }
      this.abortControllers.outbounds = new AbortController()

      // Calculate offset from pagination event
      if (event) {
        this.first.outbounds = event.first
        this.offset = event.first
      } else {
        this.first.outbounds = 0
        this.offset = 0
      }

      // Build query parameters using URLSearchParams
      const params = new URLSearchParams({
        limit: this.limit,
        offset: this.offset,
        order_by: this.order_by.outbounds
      })

      params.append('receive_is_null', 'true')

      const url = `${
        process.env.VUE_APP_API_URL
      }/dashboard/outlet-outbounds?${params.toString()}`

      this.loading.outbounds = true

      try {
        const response = await this.$http.get(url, {
          signal: this.abortControllers.outbounds.signal
        })

        if (response.status === 200) {
          this.items_outbounds = response.data.data.outlet_outbounds || []
          this.total_records_outbonds = response.data.data.total_records || 0
        } else {
          this.showToast(
            'error',
            'Error',
            'Gagal mengambil data retur & transfer'
          )
        }
      } catch (error) {
        // Don't show error if request was aborted
        if (error.name === 'AbortError') {
          return
        }
        console.error('Error fetching return list:', error)
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Terjadi kesalahan saat mengambil data retur & transfer'
        this.showToast('error', 'Error', errorMessage)
        this.items_outbounds = []
        this.total_records_outbonds = 0
      } finally {
        this.loading.outbounds = false
      }
    },

    /**
     * Handle inbounds pagination
     */
    onInboundsPage(event) {
      this.first.inbounds = event.first
      this.getListOutletInbounds(event)
    },

    async getListOutletInbounds(event = null) {
      // Cancel previous request if exists
      if (this.abortControllers.inbounds) {
        this.abortControllers.inbounds.abort()
      }
      this.abortControllers.inbounds = new AbortController()

      // Calculate offset from pagination event
      if (event) {
        this.first.inbounds = event.first
        this.offset = event.first
      } else {
        this.first.inbounds = 0
        this.offset = 0
      }

      // Build query parameters using URLSearchParams
      const params = new URLSearchParams({
        limit: this.limit,
        offset: this.offset,
        order_by: this.order_by.inbounds
      })

      params.append('status', '0')

      const url = `${
        process.env.VUE_APP_API_URL
      }/dashboard/outlet-inbounds?${params.toString()}`

      this.loading.inbounds = true

      try {
        const response = await this.$http.get(url, {
          signal: this.abortControllers.inbounds.signal
        })

        if (response.status === 200) {
          this.items_inbounds = response.data.data.outlet_inbounds || []
          // FIX: Use API total instead of array length
          this.total_records_inbounds = response.data.data.total || 0
        } else {
          this.showToast(
            'error',
            'Error',
            'Gagal mengambil data penerimaan barang'
          )
        }
      } catch (error) {
        // Don't show error if request was aborted
        if (error.name === 'AbortError') {
          return
        }
        console.error('Error fetching outlet inbounds:', error)
        const errorMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Terjadi kesalahan saat mengambil data penerimaan barang'
        this.showToast('error', 'Error', errorMessage)
        this.items_inbounds = []
        this.total_records_inbounds = 0
      } finally {
        this.loading.inbounds = false
      }
    },

    goTo(section) {
      if (section === 'catalog') this.$router.push({ path: '/catalog/list' })
      if (section === 'purchase') this.$router.push({ path: '/purchase/list' })
      if (section === 'supplier') this.$router.push({ path: '/supplier/list' })
      if (section === 'create-purchase')
        this.$router.push({ path: '/purchase/create' })
      if (section === 'create-supplier')
        this.$router.push({ path: '/supplier/create' })
    }
  },

  beforeDestroy() {
    // Cancel all pending requests
    Object.keys(this.abortControllers).forEach(key => {
      if (this.abortControllers[key]) {
        this.abortControllers[key].abort()
        this.abortControllers[key] = null
      }
    })

    // Dispose chart instance
    if (this.chartInstance) {
      window.removeEventListener('resize', this.handleChartResize)
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-purchasing-section {
  margin-top: 2rem;
}
.dashboard-actions {
  margin-bottom: 1.5rem;
  display: flex;
  gap: 1rem;
}
.action-btn {
  background: #1976d2;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 0.7rem 1.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.action-btn:hover {
  background: #125ea2;
}
.card-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}
.dashboard-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  padding: 1.5rem;
  min-width: 220px;
  flex: 1 1 220px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.dashboard-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}
.card-icon {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}
.card-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.25rem;
}
.card-desc {
  font-size: 1rem;
  color: #666;
  margin-bottom: 0.5rem;
}
.latest-card ul {
  margin: 0;
  padding-left: 1.2rem;
}
.latest-card li {
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
}
</style>
